const swiperSliders = document.querySelectorAll('.swiper');

function initializeSwiper(elementID) {
	const swiper = new Swiper('#' + elementID, {
		// Optional parameters
		direction: 'horizontal',
		loop: true,

		//Pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		//keyboard control
		keyboard: {
			enabled: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}

if(swiperSliders.length > 0) {
	document.addEventListener('DOMContentLoaded', function() {
		swiperSliders.forEach(slider => {
			const sliderID = slider.getAttribute('id');
			initializeSwiper(sliderID);
		});
	});
}